import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import infoImg from "../../assets/images/info.svg";
import "./admin-console.scss";

const NAV_ITEMS = [
  { id: "health", label: "System Health", section: "SYSTEM", roles: ["admin", "developer"] },
  { id: "sessions", label: "Session Review", section: "REVIEW", roles: ["admin"] },
  { id: "payouts", label: "Payouts", section: "REVIEW", roles: ["admin"] },
  { id: "assignments", label: "Manual Assignment", section: "PLAYTESTS", roles: ["admin"] },
  { id: "game-assignments", label: "Game Assignments", section: "PLAYTESTS", roles: ["admin"] },
  { id: "reports", label: "Feedback Reports", section: "PLAYTESTS", roles: ["admin"] },
  { id: "studios", label: "Developer Dashboards", section: "PLAYTESTS", roles: ["admin"] },
];

function AdminLayout({
  children,
  activeTab,
  onTabChange,
  flaggedCount,
  pendingCount = 0,
  pendingGames = [],
  onRefresh,
  showRefresh,
  viewerRole = "admin",
}) {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const visibleItems = NAV_ITEMS.filter((item) => item.roles.includes(viewerRole));
  const sections = ["SYSTEM", "REVIEW", "PLAYTESTS"].filter((section) =>
    visibleItems.some((item) => item.section === section)
  );
  const breadcrumb = (visibleItems.find((item) => item.id === activeTab)?.label || "Admin").toUpperCase();

  const closeSidebar = () => setSidebarOpen(false);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("name");
    localStorage.removeItem("username");
    localStorage.removeItem("immerselyEmail");
    localStorage.removeItem("userId");
    localStorage.removeItem("userData");
    navigate("/");
  };

  return (
    <div className="admin-console">
      <div
        className={`admin-sidebar-backdrop ${sidebarOpen ? "admin-sidebar-backdrop--visible" : ""}`}
        onClick={closeSidebar}
        aria-hidden="true"
      />

      <aside className={`admin-sidebar ${sidebarOpen ? "admin-sidebar--open" : ""}`}>
        <div className="admin-sidebar-brand">
          <img src={infoImg} alt="Immersely" />
          <span>{viewerRole === "developer" ? "STAFF" : "ADMIN"}</span>
        </div>

        <nav className="admin-sidebar-nav" aria-label="Admin navigation">
          {sections.map((section) => (
            <div key={section} className="admin-nav-section">
              <div className="admin-nav-label">{section}</div>
              {visibleItems.filter((item) => item.section === section).map((item) => (
                <button
                  key={item.id}
                  type="button"
                  className={`admin-nav-link ${activeTab === item.id ? "admin-nav-link--active" : ""}`}
                  onClick={() => {
                    onTabChange(item.id);
                    closeSidebar();
                  }}
                >
                  {item.label}
                  {item.id === "sessions" && flaggedCount > 0 && (
                    <span className="admin-nav-badge">{flaggedCount}</span>
                  )}
                  {item.id === "assignments" && pendingCount > 0 && (
                    <span className="admin-nav-badge">{pendingCount}</span>
                  )}
                </button>
              ))}
            </div>
          ))}
        </nav>
        <div className="admin-sidebar-footer">
          <button
            type="button"
            className="admin-nav-link"
            onClick={() => {
              closeSidebar();
              navigate("/settings");
            }}
          >
            Settings
          </button>
          <button type="button" className="admin-nav-link" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </aside>

      <div className="admin-main">
        <header className="admin-topbar">
          <div className="admin-topbar-left">
            <button
              type="button"
              className="admin-menu-toggle"
              onClick={() => setSidebarOpen((prev) => !prev)}
              aria-label="Toggle navigation"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            </button>
            <div className="admin-breadcrumbs">
              IMMERSELY // <span>{breadcrumb}</span>
            </div>
          </div>
          <div className="admin-topbar-actions">
            {showRefresh && (
              <button type="button" className="admin-btn admin-btn--ghost" onClick={onRefresh}>
                Refresh
              </button>
            )}
            <button type="button" className="admin-btn admin-btn--ghost" onClick={() => navigate("/settings")}>
              Settings
            </button>
            <button type="button" className="admin-btn admin-btn--ghost" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </header>
        {pendingCount > 0 && viewerRole === "admin" && (
          <div className="admin-pending-banner" role="status">
            <div className="admin-pending-banner-copy">
              <strong>
                {pendingCount === 1
                  ? "1 client game is waiting for playtester assignment"
                  : `${pendingCount} client games are waiting for playtester assignment`}
              </strong>
              {pendingGames[0]?.name && (
                <span>
                  {pendingCount === 1
                    ? pendingGames[0].name
                    : `Latest: ${pendingGames[0].name}`}
                </span>
              )}
            </div>
            {activeTab !== "assignments" && (
              <button
                type="button"
                className="admin-btn admin-btn--ghost"
                onClick={() => onTabChange("assignments")}
              >
                Assign now
              </button>
            )}
          </div>
        )}
        <main className="admin-page">{children}</main>
      </div>
    </div>
  );
}

export default AdminLayout;
